import FlightAutoBillHandler from '@itinerary/trip/flight/FlightAutoBillHandler';
import FlightPriceClass from '@itinerary/trip/flight/FlightPriceClass';
import { type PassengerCount } from '@itinerary/types';
import { PassengerFields } from '@store/form';
import { PaxType } from '@utils/types';
import { PaxTypeTitles } from '@itinerary/trip/TripModuleTypes';
import VerifyResult from '@itinerary/VerifyResult';
import PassengerForm from '@itinerary/PassengerForm';

export default class FlightAutoPriceClass extends FlightPriceClass {
    constructor(international?: boolean, paxCount?: PassengerCount) {
        super({}, international, paxCount);
    }

    override hasBaggage = true;
    override verify(
        count: {
            adultCount: number;
            childCount: number;
            infantCount: number;
        },
        billId: number | null
    ): Promise<VerifyResult> {
        const defaultFields =
            PassengerFields.FirstName |
            PassengerFields.LastName |
            PassengerFields.Gender |
            PassengerFields.Nationality |
            PassengerFields.BirthDate;

        let iranianExtraFields = PassengerFields.NationalCode;
        const foreignerExtraFields =
            PassengerFields.NationalityCode |
            PassengerFields.PassportExpiry |
            PassengerFields.PassportNumber;

        if (this.international) {
            iranianExtraFields |=
                PassengerFields.PassportExpiry | PassengerFields.PassportNumber;
        }

        const adultForm: PassengerForm = new PassengerForm({
            title: PaxTypeTitles[PaxType.Adult],
            type: PaxType.Adult,
            defaultFields,
            iranianExtraFields,
            foreignerExtraFields,
        });

        const childForm: PassengerForm = new PassengerForm({
            title: PaxTypeTitles[PaxType.Child],
            type: PaxType.Child,
            defaultFields,
            iranianExtraFields,
            foreignerExtraFields,
        });

        const infantForm: PassengerForm = new PassengerForm({
            title: PaxTypeTitles[PaxType.Infant],
            type: PaxType.Infant,
            defaultFields,
            iranianExtraFields,
            foreignerExtraFields,
        });

        return Promise.resolve(
            new VerifyResult(new FlightAutoBillHandler(), {
                billCode: undefined,
                remainingTime: 10,
                payablePrice: 0,
                totalPrice: 0,
                priceEntries: [],
                discount: 0,
                discountType: undefined,
                adultForm,
                childForm,
                infantForm,
                paxList: [
                    ...Array(count.adultCount)
                        .fill(0)
                        .map(_ => adultForm.clone()),

                    ...Array(count.childCount)
                        .fill(0)
                        .map(_ => childForm.clone()),

                    ...Array(count.infantCount)
                        .fill(0)
                        .map(_ => infantForm.clone()),
                ],
                cancellationTerms: '',
                billId: billId || undefined,
                needsDestinationMobile: this.international,
                warningMessages: [],
                loadDefaultPassenger: false,
                maxCapacity: 0,
                extraInfoFields: [],
            })
        );
    }
}
